export const SCHEME = 'scheme';
export const KLARNA = 'klarna';
export const KLARNA_ACCOUNT = 'klarna_account';
export const KLARNA_PAYNOW = 'klarna_paynow';
export const TRUSTLY = 'trustly';
export const MOBILEPAY = 'mobilepay';
export const APPLEPAY = 'applepay';
export const IDEAL = 'ideal';
export const PAY_PAL = 'paypal';
export const BLIK = 'blik';
export const ONLINE_BANKING_PL = 'onlineBanking_PL';
export const PAY_PO = 'paypo';
export const KAMMERKOLLEGIET = 'kammerkollegiet';
export const MASTERCARD = 'mastercard';
export const VISA = 'visa';
export const NETS = 'nets';
export const CREDIT_CARD = 'CreditCard';
